import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navRef = useRef(null);

  const handleLinkClick = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open && navRef.current && !navRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <nav className="navbar" ref={navRef}>
      <div className={`nav-links ${open ? 'active' : ''}`}>
        <Link to="/" onClick={handleLinkClick}>Home</Link>
        <Link to="/N_servicios" onClick={handleLinkClick}>¿Quienes somos y como lo hacemos?</Link>
        <Link to="/N_plus" onClick={handleLinkClick}>Sello de calidad</Link>
        <Link to="/P_tiempos" onClick={handleLinkClick}>Precios y tiempos</Link>
        
        <Link to="/Hablamos" onClick={handleLinkClick}>Contáctanos</Link>
        
      </div>

      <div className="burger" onClick={() => setOpen(!open)}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
    </nav>
  );
};

export default Navbar;
